import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { ModalReducerStateIdKeys } from "@/app_redux/reducers/reducer_interface";

/* returns modal show state */
export const useModal = (modalId: ModalReducerStateIdKeys) => {
  const modalState = useAppSelector((state) => state.modals[modalId]);
  return modalState;
};
